import { DialogActions, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { getSalesReturn } from "../../../../services/sales/salesService";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import {
  CustomOutlinedDisabledCurrencyField,
  CustomOutlinedDisabledTextField,
} from "../../../../partials/content/Forms";
import { formatDate } from "../../../../utils/utils";
import { Card, Table } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { Accordion, AccordionTab } from "primereact/accordion";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import Illustration from "../../../../partials/content/Illustration";
import SalesReturnItemsRequest from "./SalesReturnItemsRequest";
import SalesReturnInvoices from "./SalesReturnInvoices";

function SalesReturnDetail({ salesReturnID = 0, onCloseSalesReturn }) {
  const { reload } = useGlobalData();
  const [activeIndex, setActiveIndex] = useState(0);
  const [salesReturn, setSalesReturn] = useState(null);
  const handleGetSalesReturn = async (salesReturnID = 0) => {
    const response = await getSalesReturn(salesReturnID);
    const { data } = response.data;
    setSalesReturn(data.salesReturn);
  };
  useEffect(() => {
    handleGetSalesReturn(salesReturnID);
  }, [salesReturnID, reload]);
  return (
    <React.Fragment>
      <TabView className="tabview" scrollable>
        <TabPanel header="Basic Info" rightIcon="fas fa-th-large">
          {salesReturn !== null ? (
            <React.Fragment>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  {salesReturn.salesPosID > 0 ? (
                    <CustomOutlinedDisabledTextField
                      label="Sales POS ID"
                      value={salesReturn.salesPosID}
                    />
                  ) : (
                    <CustomOutlinedDisabledTextField
                      label="Sales Order ID"
                      value={salesReturn.salesOrderID}
                    />
                  )}
                  <div className="row">
                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <CustomOutlinedDisabledTextField
                        label="Currency"
                        value={salesReturn.currency.currencyCode}
                      />
                    </div>
                    <div className="col-sm-8 col-md-8 col-lg-8">
                      <CustomOutlinedDisabledCurrencyField
                        label="Sales Amount"
                        value={salesReturn.salesAmount}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Return Warehouse"
                        value={salesReturn.retWarehouse.warehouseName}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Request From Warehouse"
                        value={salesReturn.reqWarehouse.warehouseName}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomOutlinedDisabledTextField
                    label="Process Type"
                    value={salesReturn.processTypeName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Return Date"
                    value={formatDate(salesReturn.returnDate)}
                  />
                  <CustomOutlinedDisabledCurrencyField
                    label="Total Paid Amount"
                    value={salesReturn.totalPaidAmount}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="accordion">
                    <div className="card">
                      <Accordion
                        className="accordion"
                        activeIndex={activeIndex}
                        onTabChange={(e) => setActiveIndex(e.index)}
                      >
                        <AccordionTab
                          header={
                            <React.Fragment>
                              <i className="fas fa-sitemap"></i>
                              <span>
                                <strong>Sales Return Items</strong>
                              </span>
                            </React.Fragment>
                          }
                        >
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mb-3">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <div className="card">
                                    <Table
                                      striped
                                      borderless
                                      size="sm"
                                      responsive="xl"
                                    >
                                      {salesReturn.salesReturnItems &&
                                      salesReturn.salesReturnItems.length >
                                        0 ? (
                                        <thead>
                                          <tr>
                                            <th>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Item Name
                                              </Typography>
                                            </th>
                                            <th>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Return Qty
                                              </Typography>
                                            </th>
                                            <th>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Unit
                                              </Typography>
                                            </th>
                                            <th>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Batch ID
                                              </Typography>
                                            </th>
                                            <th>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Reason
                                              </Typography>
                                            </th>
                                          </tr>
                                        </thead>
                                      ) : null}
                                      <tbody>
                                        {salesReturn.salesReturnItems &&
                                        salesReturn.salesReturnItems.length >
                                          0 ? (
                                          salesReturn.salesReturnItems.map(
                                            (item, index) => (
                                              <tr
                                                key={index}
                                                className="border-top"
                                              >
                                                <td>
                                                  <Typography className="mx-1 my-1">
                                                    {item.itemType > 0 ? (
                                                      <span>
                                                        <BootstrapTooltip
                                                          title={
                                                            item.itemTypeName
                                                          }
                                                        >
                                                          <span className="mr-2">
                                                            <i
                                                              className={
                                                                item.itemType ===
                                                                1
                                                                  ? "fas fa-boxes text-success"
                                                                  : item.itemType ===
                                                                    2
                                                                  ? "fas fa-tools text-primary"
                                                                  : item.itemType ===
                                                                    3
                                                                  ? "fas fa-building text-info"
                                                                  : item.itemType ===
                                                                    4
                                                                  ? "fas fa-boxes text-warning"
                                                                  : item.itemType ===
                                                                    5
                                                                  ? "fas fa-boxes text-danger"
                                                                  : null
                                                              }
                                                            ></i>
                                                          </span>
                                                        </BootstrapTooltip>
                                                        <span>
                                                          {item.itemCode}{" "}
                                                          {item.itemName}
                                                        </span>
                                                      </span>
                                                    ) : (
                                                      <React.Fragment>
                                                        {item.itemCode}{" "}
                                                        {item.itemName}
                                                      </React.Fragment>
                                                    )}
                                                  </Typography>
                                                </td>
                                                <td>
                                                  <Typography className="mx-1 my-1">
                                                    {item.qtyReturn}
                                                  </Typography>
                                                </td>
                                                <td>
                                                  <Typography className="mx-1 my-1">
                                                    {item.uom.uomName}
                                                  </Typography>
                                                </td>
                                                <td>
                                                  <Typography className="mx-1 my-1">
                                                    {item.batchID}
                                                  </Typography>
                                                </td>
                                                <td>
                                                  <Typography className="mx-1 my-1">
                                                    {item.reasonName}
                                                  </Typography>
                                                </td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              className="text-center py-3"
                                              colSpan="6"
                                            >
                                              <Illustration
                                                imageSource="INVIFO Procurement.png"
                                                guidance="You don't have any Sales Return items yet"
                                                guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                                size="sm"
                                              ></Illustration>
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </div>
                              </div>
                              {salesReturn.processType === 2 ? (
                                <div className="row">
                                  <div className="col-sm-12 col-md-6 col-lg-6"></div>
                                  <div className="col-sm-12 col-md-6 col-lg-6">
                                    <Card>
                                      <Card.Body className="pb-0">
                                        <Table
                                          borderless
                                          size="sm"
                                          responsive="xl"
                                        >
                                          <tbody>
                                            <tr className="border-bottom">
                                              <td style={{ width: "50%" }}>
                                                <Typography className="mb-3 kt-font-bolder">
                                                  Sub Total
                                                </Typography>
                                              </td>
                                              <td style={{ width: "0%" }}></td>
                                              <td style={{ width: "0%" }}></td>
                                              <td style={{ width: "50%" }}>
                                                <Typography
                                                  component="div"
                                                  className="mb-3 kt-font-bolder"
                                                >
                                                  <NumberFormat
                                                    value={
                                                      salesReturn.subTotalRet
                                                    }
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    decimalScale={2}
                                                    renderText={(value) => (
                                                      <div className="float-right">
                                                        {
                                                          salesReturn.currency
                                                            .currencyCode
                                                        }{" "}
                                                        {value}
                                                      </div>
                                                    )}
                                                  />
                                                </Typography>
                                              </td>
                                            </tr>
                                            <tr className="border-bottom">
                                              <td>
                                                <Typography
                                                  component="div"
                                                  className="my-3"
                                                >
                                                  <NumberFormat
                                                    value={
                                                      salesReturn.discountPercent
                                                    }
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    decimalScale={2}
                                                    renderText={(value) => (
                                                      <div>
                                                        Discount{" ("}
                                                        {value}
                                                        {"%)"}
                                                      </div>
                                                    )}
                                                  />
                                                </Typography>
                                              </td>
                                              <td></td>
                                              <td></td>
                                              <td>
                                                <Typography
                                                  component="div"
                                                  className="my-3"
                                                >
                                                  <NumberFormat
                                                    value={
                                                      salesReturn.discountAmount
                                                    }
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    decimalScale={2}
                                                    renderText={(value) => (
                                                      <div className="float-right">
                                                        -{" "}
                                                        {
                                                          salesReturn.currency
                                                            .currencyCode
                                                        }{" "}
                                                        {value}
                                                      </div>
                                                    )}
                                                  />
                                                </Typography>
                                              </td>
                                            </tr>
                                            <tr className="border-bottom">
                                              <td>
                                                <Typography
                                                  component="div"
                                                  className="my-3"
                                                >
                                                  <NumberFormat
                                                    value={
                                                      salesReturn.taxPercent
                                                    }
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    decimalScale={2}
                                                    renderText={(value) => (
                                                      <div>
                                                        Tax{" ("}
                                                        {value}
                                                        {"%)"}
                                                      </div>
                                                    )}
                                                  />
                                                </Typography>
                                              </td>
                                              <td></td>
                                              <td></td>
                                              <td>
                                                <Typography
                                                  component="div"
                                                  className="my-3"
                                                >
                                                  <NumberFormat
                                                    value={
                                                      salesReturn.taxAmount
                                                    }
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    decimalScale={2}
                                                    renderText={(value) => (
                                                      <div className="float-right">
                                                        {
                                                          salesReturn.currency
                                                            .currencyCode
                                                        }{" "}
                                                        {value}
                                                      </div>
                                                    )}
                                                  />
                                                </Typography>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </Table>
                                      </Card.Body>
                                      <Card.Footer>
                                        <Table
                                          borderless
                                          size="sm"
                                          responsive="xl"
                                        >
                                          <tbody>
                                            <tr>
                                              <td style={{ width: "50%" }}>
                                                <Typography
                                                  variant="h6"
                                                  className="kt-font-bolder"
                                                >
                                                  Grand Total
                                                </Typography>
                                              </td>
                                              <td style={{ width: "0%" }}></td>
                                              <td style={{ width: "0%" }}></td>
                                              <td style={{ width: "50%" }}>
                                                <Typography
                                                  variant="h6"
                                                  component="div"
                                                  className="kt-font-bolder"
                                                >
                                                  <NumberFormat
                                                    value={
                                                      salesReturn.grandTotalRet
                                                    }
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    decimalScale={2}
                                                    renderText={(value) => (
                                                      <div className="float-right">
                                                        {
                                                          salesReturn.currency
                                                            .currencyCode
                                                        }{" "}
                                                        {value}
                                                      </div>
                                                    )}
                                                  />
                                                </Typography>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </Table>
                                      </Card.Footer>
                                    </Card>
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </AccordionTab>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : null}
        </TabPanel>
        <TabPanel header="Items Request" rightIcon="fas fa-th-large">
          {salesReturn !== null ? (
            <SalesReturnItemsRequest
              salesReturnID={salesReturnID}
              itemsRequestImp={salesReturn.itemsRequest}
              onReloadData={() => {
                handleGetSalesReturn(salesReturnID);
              }}
            />
          ) : null}
        </TabPanel>
        <TabPanel header="A/P Invoices" rightIcon="fas fa-th-large">
          {salesReturn !== null ? (
            <SalesReturnInvoices invoicesImp={salesReturn.incomingInvoice} />
          ) : null}
        </TabPanel>
      </TabView>

      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseSalesReturn();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
      </DialogActions>
    </React.Fragment>
  );
}

export default SalesReturnDetail;
